/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
import FormControlContext from "./FormControlContext.js";
export default function useFormControl() {
    return React.useContext(FormControlContext);
}
